/**
 * @class
 * @function BackToTop
 */
if (!customElements.get('back-to-top')) {
  class BackToTop extends HTMLElement {
    constructor() {
      super();
      this.pageHeight = window.innerHeight;

      // Bind event handlers once in the constructor
      this.checkVisible = this.checkVisible.bind(this);
      this.onClick = this.onClick.bind(this);
    }

    connectedCallback() {
      // Add event listeners with appropriate options
      this.addEventListener('click', this.onClick);
      this.addEventListener('touchstart', this.onClick, { passive: true });
      window.addEventListener('scroll', this.checkVisible, { passive: true });
    }

    disconnectedCallback() {
      // Clean up event listeners when the element is removed
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('touchstart', this.onClick, { passive: true });
      window.removeEventListener('scroll', this.checkVisible, { passive: true });
    }

    checkVisible() {
      // Use requestAnimationFrame for efficient updates
      window.requestAnimationFrame(() => {
        const y = window.scrollY;
        if (y > this.pageHeight) {
          this.classList.add('back-to-top--active');
        } else {
          this.classList.remove('back-to-top--active');
        }
      });
    }

    onClick() {
      // Smoothly scroll to the top of the page
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
      });
    }
  }

  customElements.define('back-to-top', BackToTop);
}
